var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/bank"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bank"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.75 12.5001H3.75C2.79 12.5001 2 11.7101 2 10.7501V7.43013C2 6.75013 2.46998 6.06013 3.09998 5.81013L12.1 2.21016C12.48 2.06016 13.02 2.06016 13.4 2.21016L22.4 5.81013C23.03 6.06013 23.5 6.76013 23.5 7.43013V10.7501C23.5 11.7101 22.71 12.5001 21.75 12.5001ZM12.75 3.59016C12.71 3.59016 12.67 3.59011 12.65 3.60011L3.65997 7.20015C3.59997 7.23015 3.5 7.36013 3.5 7.43013V10.7501C3.5 10.8901 3.61 11.0001 3.75 11.0001H21.75C21.89 11.0001 22 10.8901 22 10.7501V7.43013C22 7.36013 21.91 7.23015 21.84 7.20015L12.84 3.60011C12.82 3.59011 12.79 3.59016 12.75 3.59016Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.75 23.5H2.75C2.34 23.5 2 23.16 2 22.75V19.75C2 18.79 2.79 18 3.75 18H21.75C22.71 18 23.5 18.79 23.5 19.75V22.75C23.5 23.16 23.16 23.5 22.75 23.5ZM3.5 22H22V19.75C22 19.61 21.89 19.5 21.75 19.5H3.75C3.61 19.5 3.5 19.61 3.5 19.75V22Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.75 19.5C4.34 19.5 4 19.16 4 18.75V11.75C4 11.34 4.34 11 4.75 11C5.16 11 5.5 11.34 5.5 11.75V18.75C5.5 19.16 5.16 19.5 4.75 19.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.75 19.5C8.34 19.5 8 19.16 8 18.75V11.75C8 11.34 8.34 11 8.75 11C9.16 11 9.5 11.34 9.5 11.75V18.75C9.5 19.16 9.16 19.5 8.75 19.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.75 19.5C12.34 19.5 12 19.16 12 18.75V11.75C12 11.34 12.34 11 12.75 11C13.16 11 13.5 11.34 13.5 11.75V18.75C13.5 19.16 13.16 19.5 12.75 19.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.75 19.5C16.34 19.5 16 19.16 16 18.75V11.75C16 11.34 16.34 11 16.75 11C17.16 11 17.5 11.34 17.5 11.75V18.75C17.5 19.16 17.16 19.5 16.75 19.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M20.75 19.5C20.34 19.5 20 19.16 20 18.75V11.75C20 11.34 20.34 11 20.75 11C21.16 11 21.5 11.34 21.5 11.75V18.75C21.5 19.16 21.16 19.5 20.75 19.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M23.75 23.5H1.75C1.34 23.5 1 23.16 1 22.75C1 22.34 1.34 22 1.75 22H23.75C24.16 22 24.5 22.34 24.5 22.75C24.5 23.16 24.16 23.5 23.75 23.5Z",
    fill: "#00535C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.75 10C11.51 10 10.5 8.99 10.5 7.75C10.5 6.51 11.51 5.5 12.75 5.5C13.99 5.5 15 6.51 15 7.75C15 8.99 13.99 10 12.75 10ZM12.75 7C12.34 7 12 7.34 12 7.75C12 8.16 12.34 8.5 12.75 8.5C13.16 8.5 13.5 8.16 13.5 7.75C13.5 7.34 13.16 7 12.75 7Z",
    fill: "#00535C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.6662c5b9.svg";
export { ForwardRef as ReactComponent };